import CustomCard from "components/Atoms/CustomCard"
import React from "react"
import DispatchList from "./table/DispatchList"
import DispatchTableHeader from "./table/DispatchTableHeader"

const DispatchTable = () => {
  return (
    <div className="p-3">
      <CustomCard className="vt-dispatch-table-view p-0">
        <DispatchTableHeader />
        <DispatchList />
        {/* <CustomReactTable />   */}
      </CustomCard>
    </div>
  )
}

export default DispatchTable
